module.exports = __webpack_public_path__ + "assets/img/map-en.5450e60c.png";